"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../gen-src/Localize");
var GraphQLErrorFunctions_1 = require("../error/functions/GraphQLErrorFunctions");
function reportConnectToGraphQLErrors(errors) {
    return (errors.map(function (error, i) {
        var errorCode = GraphQLErrorFunctions_1.getGraphQLErrorCode(error);
        var severity = errorCode == null || GraphQLErrorFunctions_1.isFatalError(errorCode) ? widgets_1.ToastType.Error : widgets_1.ToastType.Warning;
        return errorToast(GraphQLErrorFunctions_1.getToastMessageForErrorCode(errorCode), i, severity);
    }));
}
exports.reportConnectToGraphQLErrors = reportConnectToGraphQLErrors;
function reportConnectToWebClientErrors(errors) {
    return (errorToast(Localize_1.Messages.ErrorWithoutErrorCode(), 0, widgets_1.ToastType.Error));
}
exports.reportConnectToWebClientErrors = reportConnectToWebClientErrors;
function errorToast(message, errorNumber, severity) {
    return (React.createElement(ConnectToErrorToast, { key: "error_" + errorNumber, errorNumber: errorNumber, message: message, toastType: severity }));
}
var ConnectToErrorToast = /** @class */ (function (_super) {
    __extends(ConnectToErrorToast, _super);
    function ConnectToErrorToast(props) {
        var _this = _super.call(this, props) || this;
        _this.onCloseRequest = function () {
            _this.setState({ showToast: false });
        };
        _this.state = { showToast: true };
        return _this;
    }
    ConnectToErrorToast.prototype.render = function () {
        return this.state.showToast
            ? (React.createElement(widgets_1.ToastWidget, { message: this.props.message, onCloseRequest: this.onCloseRequest, toastType: this.props.toastType }))
            : null;
    };
    return ConnectToErrorToast;
}(React.PureComponent));
exports.ConnectToErrorToast = ConnectToErrorToast;
//# sourceMappingURL=ConnectToErrorHandling.js.map